<template>
  <div class="container">
    <h1 class="title">Hallo {{ userName }}</h1>
    <h2 class="subtitle">
      Inhalte verwalten
    </h2>
    <div class="box">
      <div class="columns"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Overview',
  computed: {
    ...mapGetters({
      userName: 'userName',
    }),
  },
  data() {
    return {
      metrics: [],
    }
  },
  async mounted() {},
}
</script>
